import { takeEvery, call, put } from 'redux-saga/effects';

import actionTypes from '../actionTypes';
import { saveData, patchData } from '../service/saveDataService';
import APIENDPOINTS from '../../constants/apiconstants';
import {
	saveFirstTimeUserStatusSuccess,
	saveFirstTimeUserStatusFailure,
	disabledsADAlertSuccess,
	disabledsADAlertFailure,
} from '../actions/appGuideActions';

export function* saveFirstTimeUserStatusSaga(action) {
	const { portalUserContext } = action.payload;
	try {
		const response = yield call(
			saveData,
			{ firstTimeUser: false },
			`${APIENDPOINTS.USER_PREF_URL}/v1/save`,
			portalUserContext.result
		);
		if (response?.statusCode !== 200) {
			yield put(
				saveFirstTimeUserStatusFailure(
					response?.json?.error || response?.statusCode
				)
			);
		} else {
			yield put(saveFirstTimeUserStatusSuccess());
		}
	} catch (error) {
		yield put(saveFirstTimeUserStatusFailure(error?.message));
	}
}

export function* disabledsADAlertSaga(action) {
	const { portalUserContext, value } = action.payload;
	try {
		const response = yield call(
			patchData,
			{},
			`${APIENDPOINTS.USER_PREF_URL}/v1/dsADAlert?value=${value}`,
			portalUserContext.result,
			false
		);
		if (response?.statusCode !== 200) {
			yield put(
				disabledsADAlertFailure(response?.json?.error || response?.statusCode)
			);
		} else {
			yield put(disabledsADAlertSuccess());
		}
	} catch (error) {
		yield put(disabledsADAlertFailure(error?.message));
	}
}

export function* appGuideSagaWatcher() {
	yield takeEvery(
		actionTypes.SAVE_FIRST_TIME_USER_STATUS,
		saveFirstTimeUserStatusSaga
	);
	yield takeEvery(actionTypes.DISABLE_DSADALERT, disabledsADAlertSaga);
}
